export const YEAR_EXPIRATION_DATE = 365;
